var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltipText,
    offset: 12,
    trigger: 'manual',
    show: _vm.tooltipOpen,
  }),expression:"{\n    content: tooltipText,\n    offset: 12,\n    trigger: 'manual',\n    show: tooltipOpen,\n  }"}],staticClass:"signing-action",class:{ disabled: _vm.previewDisable },on:{"click":_vm.handleClick}},[(_vm.printing)?_c('LoaderCircular',{staticClass:"loader",attrs:{"size":_vm.EnumSizes.tiny}}):_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.option.icon}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(_vm.option.title)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }